import { useContext, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import AuthContext from "../../context/authContext";
import Loading from "../../components/Loading";
import "./LoginPage.css"; // Importe o arquivo CSS

const sanitizeInput = (input) => input.replace(/<[^>]*>/g, "").trim();

function LoginPage() {
    const { loginUser } = useContext(AuthContext);
    const navigate = useNavigate();
    const location = useLocation();

    // Pegando a página anterior do estado ou definindo um fallback
    const from = location.state?.from || "/cart";

    const [loading, setLoading] = useState(false);
    const [loadingTimeout, setLoadingTimeout] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrorMessage("");

        const sanitizedEmail = sanitizeInput(e.target.email.value);
        const sanitizedPassword = sanitizeInput(e.target.password.value);

        if (!sanitizedEmail || !sanitizedPassword) {
            setErrorMessage("Preencha todos os campos.");
            return;
        }

        setLoading(true);
        const timeoutId = setTimeout(() => setLoadingTimeout(true), 5000);

        try {
            const success = await loginUser(sanitizedEmail, sanitizedPassword);
            if (success) {
                navigate(from, { replace: true }); // Redireciona para a página anterior
            }
        } catch (error) {
            setErrorMessage("Credenciais inválidas. Verifique e tente novamente.");
        } finally {
            clearTimeout(timeoutId);
            setLoading(false);
            setLoadingTimeout(false);
        }
    };

    if (loading) {
        return (
            <div className="loading-container">
                {loadingTimeout ? (
                    <p className="loading-message">Carregamento demorado, aguarde...</p>
                ) : (
                    <Loading />
                )}
            </div>
        );
    }

    return (
        <div className="login-container">
            <div className="login-box">
                <h2>Bem-vindo ao NWayami-store</h2>
                {errorMessage && <p className="error-message">{errorMessage}</p>}
                <form onSubmit={handleSubmit}>
                    <div>
                        <input
                            name="email"
                            type="email"
                            placeholder="Email"
                            required
                            pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}"
                        />
                    </div>
                    <div>
                        <input name="password" type="password" placeholder="Senha" required />
                    </div>
                    <button type="submit">Entrar</button>
                </form>
                <p>
                    Ainda não tem uma conta? <Link to="/register">Registre-se aqui</Link>
                </p>
            </div>
        </div>
    );
}

export default LoginPage;
